import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import AddressModel from '../../../models/AddressModel';
import DataService from "../../../services/data.service";
import { BusinessPartnerProps } from '../../../types/IdProps';
import BusinessPartner_popup_AddAddress from '../Popups/BusinessPartner_popup_AddAddress';

const BusinessPartner_tab_Addresses: React.FC<BusinessPartnerProps> = ({ businessPartnerId, businessPartnerTypeId }) => {
    const [data, setData] = useState<AddressModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [businessPartnerId]);

    function getTableData() {
        DataService.get<AddressModel[]>('api/v1/Addresses/ByBusinessPartner/' + businessPartnerId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/Addresses/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Type', dataProp: 'addressType', sort: 'asc' },
        { title: 'Address', dataProp: 'addressLine1' },
        { title: 'Zipcode', dataProp: 'zipCode' },
        { title: 'City', dataProp: 'city'},
        { title: 'Country', dataProp: 'country'},
    ];

    if (isAuthorizedFor(ApplicationFunctions.CreateAddress) || isAuthorizedFor(ApplicationFunctions.DeleteAddress)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setShowPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtBusinessPartnerAddresses'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Address'
                navigateUrl='/plm/BusinessPartners/Address/'
            />
            <BusinessPartner_popup_AddAddress businessPartnerId={businessPartnerId} businessPartnerTypeId={businessPartnerTypeId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />
        </>
    );
}
export default BusinessPartner_tab_Addresses;